import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, CanActivate, CanDeactivate } from '@angular/router';
import { DialogService } from '../dialog-service/dialog-service.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UtilService } from '../util-service/utilService';
import { isPlatformBrowser } from '@angular/common';
export interface CanComponentDeactivate {
  hasPendingChanges(): boolean;
  discardChanges?(): void;
  savePartial?(): void;
}

@Injectable()
export class AuthGuardService {
  private readonly isBrowser: boolean;

  constructor(
    private http: HttpClient,
    public router: Router,
    public dialogService: DialogService,
    private pendingChanges: UtilService,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  canDeactivate(component: CanComponentDeactivate): Observable<boolean> {
    const isDirty =
      typeof component?.hasPendingChanges === 'function'
        ? component.hasPendingChanges()
        : this.pendingChanges.isDirty();
    if (!isDirty) {
      return of(true);
    }

    if (!this.isBrowser) {
      return of(true);
    }

    return this.dialogService
      .openConfirmDialog(
        'Abbrechen',
        'Nein',
        'Ja',
        'Möchten Sie den Vorgang wirklich abbrechen? Alle eingegebenen Daten gehen verloren.'
      )
      .pipe(
        map((confirm: boolean) => {
          if (confirm) {
            this.pendingChanges.setDirty(false);
            if (typeof component.savePartial === 'function') {
              component.savePartial();
            }
            component.discardChanges?.();
          }
          return confirm;
        })
      );

  }


  canActivate(): Observable<boolean> {
    // TODO: Use gateway endpoint to check login
    return this.http.get<boolean>('/proxy/api/v0/login').pipe(
      map(isLoggedIn => {
        if (isLoggedIn) return true;
        if (this.isBrowser) {
          this.router.navigate(['/login']);
          //Hier muss der Dialog direkt aufgerufen werden, weil die Methodensignatur
          //aus Angular heraus festgelegt ist und kein Aufruf durch eine Komponente
          //stattfindet.
          this.dialogService.openDialog(
            'Kein Zugang!',
            'Loggen Sie sich mit einem vorhandenen Account ein oder erstellen Sie einen Account um auf die BIM-SWARM-Plattform zugreifen zu können!'
          );
        }
        return false;
      }),
      catchError(err => {
        console.log('AuthGuardService: Error in check login, returning false');
        return of(false);
      })
    );
  }
}
